import React from "react";
import Pic404 from "./404.jpeg";
import "./NotFound.css";
import Navbar from "./navbar/Navbar";
import Footer from "./footer/footer";
import { Link } from "react-router-dom";

export default function PageNotFound() {
  return (
    <div className="bg-color">
      <Navbar />
      <div className="not-found">
        <img src={Pic404} alt="" width="300px" />
        <div>
          <h1>Ooops! Page not Found</h1>
          <Link to={"/"}>🡪 Go Back Home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
